import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Enso } from "../components/SacredGeometry";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Your journey begins. Welcome to the Sanctuary.");
      navigate("/membership");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 pt-20">
      <div className="flex items-center justify-center px-6 py-16 bg-sanctuary-deep order-2 lg:order-1">
        <div className="w-full max-w-md">
          <Enso className="w-12 h-12 text-gold mb-8" />
          <div className="eyebrow mb-3">Take the first step</div>
          <h1 className="font-display text-4xl text-parchment font-light mb-10">Begin your journey</h1>
          <form onSubmit={submit} className="flex flex-col gap-5" data-testid="register-form">
            <div>
              <label className="text-sm text-text-muted mb-2 block">Your name</label>
              <input required value={name} onChange={(e) => setName(e.target.value)}
                className="w-full bg-sanctuary-card gold-border rounded-lg px-4 py-3 text-parchment focus:border-gold/50 outline-none transition-colors" data-testid="register-name-input" />
            </div>
            <div>
              <label className="text-sm text-text-muted mb-2 block">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-sanctuary-card gold-border rounded-lg px-4 py-3 text-parchment focus:border-gold/50 outline-none transition-colors" data-testid="register-email-input" />
            </div>
            <div>
              <label className="text-sm text-text-muted mb-2 block">Password <span className="text-text-dim">(min 6 characters)</span></label>
              <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-sanctuary-card gold-border rounded-lg px-4 py-3 text-parchment focus:border-gold/50 outline-none transition-colors" data-testid="register-password-input" />
            </div>
            <button type="submit" disabled={loading}
              className="mt-2 py-3 rounded-full bg-gold text-sanctuary-deep font-medium hover:bg-gold-hover transition-colors disabled:opacity-60" data-testid="register-submit-button">
              {loading ? "Preparing your altar…" : "Create my account"}
            </button>
          </form>
          <p className="mt-8 text-sm text-text-muted">
            Already walking the path?{" "}
            <Link to="/login" className="text-gold link-underline" data-testid="register-to-login">Enter here</Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-l from-sanctuary-deep/60 to-sanctuary-deep" />
        <div className="absolute bottom-16 right-12 max-w-sm text-right">
          <div className="font-jp text-gold text-3xl mb-3">はじめ</div>
          <p className="font-display text-3xl text-parchment italic">"The journey of a thousand miles begins beneath one's feet."</p>
        </div>
      </div>
    </div>
  );
}
